var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseDownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9999 23.25C17.6159 23.25 17.2319 23.103 16.9394 22.8105L10.9394 16.8105C10.3529 16.224 10.3529 15.276 10.9394 14.6895C11.5259 14.103 12.4739 14.103 13.0604 14.6895L18.0179 19.647L22.9574 14.877C23.5559 14.3025 24.5024 14.319 25.0784 14.9145C25.6544 15.51 25.6379 16.461 25.0424 17.0355L19.0424 22.8285C18.7499 23.1105 18.3749 23.25 17.9999 23.25Z",
    fill: "#2E3A59"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseDownIcon);
export default __webpack_public_path__ + "static/media/collapseDownIcon.88de1f73d76fe55c5360c0fe3801714d.svg";
export { ForwardRef as ReactComponent };